import { Box } from "@mui/material";
import { DashboardChip } from "./DashboardChip";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import React from 'react';
import SearchIcon from '@mui/icons-material/Search';

interface InspectionFailedChipProps {
    onClick?: () => void;
    isDeactivated?: boolean;
}

export const InspectionFailedChip = ({ onClick, isDeactivated }: InspectionFailedChipProps) => {
    return (
        <DashboardChip
            text={
                <Box display="flex" alignItems="center">
                    <ErrorOutlineOutlinedIcon fontSize="small" />
                </Box>
            }
            backgroundColor="#C10000"
            borderColor="#920000"
            icon={<SearchIcon />}
            onClick={onClick}
            isDeactivated={isDeactivated}
        />
    );
};